/* Selector de punto de amargor - Aceitunas Lopez - SHOP-015

   La barra se construye leyendo los radios que ya pinta el tema
   (name="Punto de amargor"), asi no puede desincronizarse de las variantes.
   Si este script no se ejecuta, el selector del tema sigue visible y se
   puede comprar igual: por eso el nativo se oculta desde aqui. */

(function () {
  'use strict';

  var NOMBRE_OPCION = 'Punto de amargor';

  var TEXTOS = {
    'Amargas': [
      'Recién machadas, sin lavar.',
      'Amargan de verdad.'
    ],
    'Un poco amargas': [
      'Con varios lavados encima.',
      'Les queda un toque amargo.'
    ],
    'Listas para aliñar': [
      'Con todos los lavados hechos.',
      'Ya no amargan. Solo les falta el aliño.'
    ]
  };

  function textosDe(valor) {
    var t = TEXTOS[valor];
      if (valor === 'Amargas' && t && /rajadas/i.test(document.title || '')) {
    return ['Recién rajadas, sin lavar.', t[1]];
  }
if (t) {
      return t;
    }
    return ['', ''];
  }

  function construir(host, nativos) {
    var id = 'amargor-' + Math.random().toString(36).slice(2, 8);

    var campo = document.createElement('fieldset');
    campo.className = 'amargor';

    var leyenda = document.createElement('legend');
    leyenda.className = 'amargor__tit';
    leyenda.textContent = '¿En qué punto las quieres?';
    campo.appendChild(leyenda);

    var ayuda = document.createElement('p');
    ayuda.className = 'amargor__ayuda';
    ayuda.textContent = 'El amargor se les va quitando lavado a lavado. Elige dónde paramos.';
    campo.appendChild(ayuda);

    var pista = document.createElement('div');
    pista.className = 'amargor__pista';

    var lista = document.createElement('ul');
    lista.className = 'amargor__paradas';
    lista.style.gridTemplateColumns = 'repeat(' + nativos.length + ', 1fr)';

    nativos.forEach(function (nativo, i) {
      var txt = textosDe(nativo.value);

      var item = document.createElement('li');
      item.className = 'amargor__parada';

      var entrada = document.createElement('input');
      entrada.type = 'radio';
      entrada.name = id;
      entrada.id = id + '-' + i;
      entrada.value = nativo.value;
      entrada.setAttribute('data-t1', txt[0]);
      entrada.setAttribute('data-t2', txt[1]);
      entrada.checked = nativo.checked;

      var etiqueta = document.createElement('label');
      etiqueta.setAttribute('for', entrada.id);

      var nombre = document.createElement('span');
      nombre.className = 'amargor__nombre';
      nombre.textContent = nativo.value;
      etiqueta.appendChild(nombre);

      item.appendChild(entrada);
      item.appendChild(etiqueta);
      lista.appendChild(item);
    });

    pista.appendChild(lista);

    if (nativos.length > 1) {
      var extremos = document.createElement('div');
      extremos.className = 'amargor__extremos';
      var izq = document.createElement('span');
      izq.textContent = 'Amargan';
      var der = document.createElement('span');
      der.textContent = 'Prácticamente dulces';
      extremos.appendChild(izq);
      extremos.appendChild(der);
      pista.appendChild(extremos);
    }

    campo.appendChild(pista);

    var detalle = document.createElement('div');
    detalle.className = 'amargor__detalle';
    detalle.setAttribute('data-amargor-detalle', '');
    var p1 = document.createElement('p');
    p1.setAttribute('data-t1', '');
    var p2 = document.createElement('p');
    p2.className = 'amargor__gusto';
    p2.setAttribute('data-t2', '');
    detalle.appendChild(p1);
    detalle.appendChild(p2);
    campo.appendChild(detalle);

    host.appendChild(campo);
    return campo;
  }

  function pintarDetalle(campo, entrada) {
    var caja = campo.querySelector('[data-amargor-detalle]');
    if (!caja || !entrada) {
      return;
    }
    var uno = caja.querySelector('p[data-t1]');
    var dos = caja.querySelector('p[data-t2]');
    if (uno) {
      uno.textContent = entrada.getAttribute('data-t1') || '';
    }
    if (dos) {
      dos.textContent = entrada.getAttribute('data-t2') || '';
    }
  }

  function init(host) {
    if (host.getAttribute('data-amargor-listo') === '1') {
      return;
    }
    var nombre = host.getAttribute('data-option-name') || NOMBRE_OPCION;
    var sel = 'input[type="radio"][name="' + nombre.replace(/"/g, '') + '"]';
    var nativos = [].slice.call(document.querySelectorAll(sel));
    if (!nativos.length) {
      return;
    }
    host.setAttribute('data-amargor-listo', '1');

    var porValor = {};
    nativos.forEach(function (n) {
      porValor[n.value] = n;
    });

    var campo = construir(host, nativos);
    var mios = [].slice.call(campo.querySelectorAll('input[type="radio"]'));

    var fieldsetNativo = nativos[0].closest('fieldset');
    if (fieldsetNativo) {
      fieldsetNativo.classList.add('amargor-nativo-oculto');
    }

    function sincronizar() {
      var marcado = null;
      nativos.forEach(function (n) {
        if (n.checked) {
          marcado = n;
        }
      });
      mios.forEach(function (m) {
        var nativo = porValor[m.value];
        var padre = m.parentNode;
        if (padre && nativo) {
          var agotada = nativo.className.indexOf('option-disabled') !== -1;
          padre.classList.toggle('is-agotada', agotada);
        }
      });
      if (marcado) {
        mios.forEach(function (m) {
          if (m.value === marcado.value) {
            if (!m.checked) {
              m.checked = true;
            }
            pintarDetalle(campo, m);
          }
        });
      }
    }

    mios.forEach(function (m) {
      m.addEventListener('change', function () {
        pintarDetalle(campo, m);
        var nativo = porValor[m.value];
        if (!nativo || nativo.checked) {
          return;
        }
        nativo.checked = true;
        nativo.dispatchEvent(new Event('change', { bubbles: true } ));
      } );
    } );

    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') {
        window.setTimeout(sincronizar, 0);
      }
    } );
    document.addEventListener('aceitunas:variantchange', function () {
      window.setTimeout(sincronizar, 0);
    } );

    sincronizar();
  }

  /* Los botones de Formato salen en una fila corrida mezclando vidrio y PET.
     Aqui se reparten en grupos con su rotulo y el boton se queda solo con el
     tamano. El valor de la opcion no se toca: en la linea de pedido sigue
     poniendo "400 g en vidrio", que es lo que necesita fabrica. */
  var FORMATOS_ENVASE = {
    'vidrio|400 g': { referencia: 'V720', ancho: 80.6, alto: 172, forma: 'recto' },
    'vidrio|2,2 kg': { referencia: 'GALON-VIDRIO', ancho: 159, alto: 254.5, forma: 'galon' },
    'pet|700 g': { referencia: 'BR1200', ancho: 99, alto: 176, forma: 'recto' },
    'pet|1,6 kg': { referencia: 'TP2700', ancho: 124, alto: 251, forma: 'recto' },
    'pet|2,2 kg': { referencia: 'BR3500', ancho: 148, alto: 242, forma: 'galon' },
    'pet|4 kg': { referencia: 'TP6300', ancho: 163, alto: 350, forma: 'garrafa' },
    'pet|10 kg': { referencia: 'CG16L', ancho: 168, alto: 162, forma: 'cubo' }
  };

  function crearSilueta(datos) {
    if (!datos) {
      return null;
    }

    if (datos.forma === 'cubo') {
      var siluetaCubo = document.createElement('span');
      siluetaCubo.className = 'fmt-silueta fmt-silueta--cubo';
      siluetaCubo.setAttribute('aria-hidden', 'true');
      siluetaCubo.setAttribute('title', datos.referencia);
      siluetaCubo.style.width = '84px';
      siluetaCubo.style.height = '78px';
      siluetaCubo.innerHTML = '<svg style="width: 84px; height: 78px;" viewBox="0 180 180 190" focusable="false">' +
        '<path class="fmt-silueta__cuerpo" d="M 15 218 Q 16 210 28 208 L 152 208 Q 164 210 165 218 L 156 344 Q 155 358 140 360 L 40 360 Q 25 358 24 344 Z" />' +
        '<path class="fmt-silueta__tapa" d="M 5 199 Q 5 193 15 191 Q 90 183 165 191 Q 175 193 175 199 L 175 211 Q 175 217 165 219 Q 90 227 15 219 Q 5 217 5 211 Z" />' +
        '<path class="fmt-silueta__detalle" d="M 7 202 Q 90 212 173 202 M 15 220 C 8 242 40 280 90 280 C 140 280 172 242 165 220 M 35 343 Q 90 351 145 343" />' +
        '</svg>';
      return siluetaCubo;
    }

    var lienzoAncho = 180;
    var base = 358;
    var x = (lienzoAncho - datos.ancho) / 2;
    var y = base - datos.alto;
    var hombro = datos.forma === 'galon' ? 25 : (datos.forma === 'garrafa' ? 30 : (datos.forma === 'cubo' ? 4 : 10));
    /* El TP6300 tiene boca de 110 mm: se representa con su ancho real. */
    var cuello = datos.forma === 'cubo' ? datos.ancho * .94 : (datos.forma === 'garrafa' ? 110 : Math.max(54, datos.ancho * .68));
    var cuelloX = (lienzoAncho - cuello) / 2;
    var cuerpoY = y + 18;
    var cuerpo = [
      'M', cuelloX, cuerpoY,
      'L', cuelloX, cuerpoY + 4,
      'Q', x, cuerpoY + hombro, x, cuerpoY + hombro * 2,
      'L', x, base - 13,
      'Q', x, base, x + 13, base,
      'L', x + datos.ancho - 13, base,
      'Q', x + datos.ancho, base, x + datos.ancho, base - 13,
      'L', x + datos.ancho, cuerpoY + hombro * 2,
      'Q', x + datos.ancho, cuerpoY + hombro, cuelloX + cuello, cuerpoY + 4,
      'L', cuelloX + cuello, cuerpoY,
      'Z'
    ].join(' ');

    var asa = datos.forma === 'garrafa' || datos.forma === 'cubo'
      ? '<path class="fmt-silueta__detalle" d="M ' + (cuelloX + cuello - 5) + ' ' + (y + 11) +
        ' Q ' + (x + datos.ancho + 13) + ' ' + (y + 20) + ' ' + (x + datos.ancho + 4) + ' ' + (y + 51) + '" />'
      : '';
    var nervios = datos.forma === 'garrafa'
      ? '<path class="fmt-silueta__detalle" d="M ' + (x + 5) + ' ' + (base - 82) + ' H ' + (x + datos.ancho - 5) +
        ' M ' + (x + 5) + ' ' + (base - 55) + ' H ' + (x + datos.ancho - 5) + '" />'
      : (datos.forma === 'galon'
        ? '<path class="fmt-silueta__detalle" d="M ' + (x + 5) + ' ' + (base - 42) + ' H ' + (x + datos.ancho - 5) + '" />'
        : '');

    var silueta = document.createElement('span');
    silueta.className = 'fmt-silueta';
    silueta.setAttribute('aria-hidden', 'true');
    silueta.setAttribute('title', datos.referencia);
    silueta.innerHTML = '<svg viewBox="0 0 180 370" focusable="false">' +
      '<path class="fmt-silueta__cuerpo" d="' + cuerpo + '" />' +
      '<rect class="fmt-silueta__tapa" x="' + (cuelloX - 3) + '" y="' + (y + 5) +
      '" width="' + (cuello + 6) + '" height="14" rx="3" />' +
      nervios + asa + '</svg>';
    return silueta;
  }

  function agruparFormato() {
    var entradas = [].slice.call(document.querySelectorAll('input[type="radio"][name="Formato"]'));
    if (!entradas.length) {
      return;
    }
    var campo = entradas[0].closest('fieldset');
    if (!campo || campo.getAttribute('data-fmt-agrupado') === '1') {
      return;
    }
    campo.setAttribute('data-fmt-agrupado', '1');

    /* El numero que ve el cliente es peso escurrido. Casi nadie lo sabe y
       casi nadie lo dice, asi que se dice aqui, en el momento de elegir. */
    var etiquetaCampo = campo.querySelector('.form__label');
    if (etiquetaCampo) {
      etiquetaCampo.textContent = 'Peso escurrido y envase';
    }
    var nota = document.createElement('p');
    nota.className = 'fmt-aviso';
    nota.innerHTML = 'Lo que pone es <strong>aceituna escurrida<\/strong>. Si pone 700 g, son 700 g de aceitunas: el agua y la salmuera no cuentan.';
    if (etiquetaCampo && etiquetaCampo.parentNode === campo) {
      campo.insertBefore(nota, etiquetaCampo.nextSibling);
    } else {
      campo.insertBefore(nota, campo.firstChild);
    }

    var grupos = {
      vidrio: { titulo: 'VIDRIO', opciones: [] },
      pet: { titulo: 'PLÁSTICO', opciones: [] }
    };

    entradas.forEach(function (entrada) {
      var etiqueta = campo.querySelector('label[for="' + entrada.id + '"]');
      if (!etiqueta) {
        return;
      }
      var partes = entrada.value.split(' en ');
      var tamano = partes[0];
      var envase = partes.length > 1 ? partes.slice(1).join(' en ') : 'Formato';
      if (/^cubo\s+/i.test(entrada.value)) {
        tamano = entrada.value.replace(/^cubo\s+/i, '');
        envase = 'Cubo';
      }
      var clave = envase.toLowerCase();
      if (clave === 'cubo') {
        clave = 'pet';
      }
      var peso = parseFloat(tamano.replace(',', '.'));
      if (tamano.toLowerCase().indexOf('kg') === -1) {
        peso = peso / 1000;
      }

      etiqueta.classList.add('fmt-opcion');

      var texto = etiqueta.querySelector('span');
      if (texto) {
        texto.textContent = tamano;
        texto.classList.add('fmt-opcion__peso');

        var silueta = crearSilueta(FORMATOS_ENVASE[clave + '|' + tamano]);
        if (silueta) {
          etiqueta.insertBefore(silueta, texto);
        }

      }

      if (!grupos[clave]) {
        return;
      }
      grupos[clave].opciones.push({
        entrada: entrada,
        etiqueta: etiqueta,
        peso: peso
      });
    });

    var contenedor = document.createElement('div');
    contenedor.className = 'fmt-grupos';
    ['vidrio', 'pet'].forEach(function (claveGrupo) {
      var datosGrupo = grupos[claveGrupo];
      if (!datosGrupo.opciones.length) {
        return;
      }
      datosGrupo.opciones.sort(function (a, b) {
        return a.peso - b.peso;
      });

      var grupo = document.createElement('div');
      grupo.className = 'fmt-grupo fmt-grupo--' + claveGrupo;

      var titulo = document.createElement('p');
      titulo.className = 'fmt-grupo__titulo';
      titulo.textContent = datosGrupo.titulo;
      grupo.appendChild(titulo);

      var opciones = document.createElement('div');
      opciones.className = 'fmt-grupo__opciones';
      datosGrupo.opciones.forEach(function (opcion) {
        opciones.appendChild(opcion.entrada);
        opciones.appendChild(opcion.etiqueta);
      });
      grupo.appendChild(opciones);
      contenedor.appendChild(grupo);
    });
    campo.appendChild(contenedor);
  }

  function simplificarBarraCompra() {
    [].slice.call(document.querySelectorAll('sticky-add-cart')).forEach(function (barra) {
      barra.classList.add('machadas-sticky-simple');

      var llamadaContenido = document.querySelector('.al-carta__cta');
      if (
        llamadaContenido &&
        barra.getAttribute('data-machadas-cta-observada') !== '1' &&
        'IntersectionObserver' in window
      ) {
        barra.setAttribute('data-machadas-cta-observada', '1');
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            barra.hidden = entry.isIntersecting;
          });
        }, { threshold: 0.15 }).observe(llamadaContenido);
      }

      function prepararBoton() {
        var boton = barra.querySelector('.product-form__submit');
        if (!boton) {
          return;
        }

        if (boton.getAttribute('type') !== 'button') {
          boton.type = 'button';
        }
        if (boton.hasAttribute('disabled')) {
          boton.removeAttribute('disabled');
        }
        if (boton.hasAttribute('name')) {
          boton.removeAttribute('name');
        }
        if (boton.getAttribute('aria-label') !== 'Elegir envase') {
          boton.setAttribute('aria-label', 'Elegir envase');
        }

        var etiqueta = boton.querySelector('.btn-label');
        if (etiqueta) {
          if (etiqueta.textContent.trim() !== 'Elegir envase') {
            etiqueta.textContent = 'Elegir envase';
          }
        } else if (boton.textContent.trim() !== 'Elegir envase') {
          boton.textContent = 'Elegir envase';
        }

        if (boton.getAttribute('data-machadas-boton') === '1') {
          return;
        }
        boton.setAttribute('data-machadas-boton', '1');
        boton.addEventListener('click', function (evento) {
          evento.preventDefault();
          evento.stopImmediatePropagation();

          var entrada = document.querySelector('input[type="radio"][name="Formato"]');
          var campoFormato = entrada ? entrada.closest('fieldset') : null;
          var destino = campoFormato ? campoFormato.querySelector('.fmt-aviso') || campoFormato : document.querySelector('.product-detail__information');
          if (!destino) {
            return;
          }

          destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      prepararBoton();
      if (barra.getAttribute('data-machadas-simple') !== '1') {
        barra.setAttribute('data-machadas-simple', '1');
        new MutationObserver(prepararBoton).observe(barra, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    });
  }

  function arrancar() {
    function sincronizarResumenes() {
    document.querySelectorAll('.product-form__input').forEach(function (grupo) {
      var resumen = grupo.querySelector('.option_value');
      var seleccionada = grupo.querySelector('input[type="radio"]:checked');
      if (resumen && seleccionada) {
        resumen.textContent = seleccionada.value;
      }
    });
  }

  document.addEventListener('change', function (evento) {
    if (!evento.target.matches('.product-form__input input[type="radio"]')) {
      return;
    }
    window.setTimeout(sincronizarResumenes, 0);
  });

  agruparFormato();
  sincronizarResumenes();
    simplificarBarraCompra();
    [].slice.call(document.querySelectorAll('[data-amargor]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
} )();
